import { Box, Button, Group, Stack, Text, Tooltip } from '@mantine/core';
import { faPlay, faStop } from '@fortawesome/pro-solid-svg-icons';
import { useEffect, useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NavLink } from 'react-router-dom';
import useSound from 'use-sound';

const DurationCell = ({ cell }) => {
    const { column, row } = cell;
    const rowData = row.original;

    const [playing, setPlaying] = useState(false);
    const [play, exposedData] = useSound(rowData.transcript?.bothAudioUrl, {
        onload: () => {
            //
        },
        onend: () => {
            setPlaying(false);
        },
    });

    return (
        <Group
            gap={'xs'}
            justify='center'
            align='center'
            wrap={false}
            miw={100}>
            <Text>{rowData.duration} sec</Text>
            <Tooltip label={playing ? 'Stop playback' : 'Play call audio'}>
                <Button
                    color={playing ? 'orange.4' : 'blue'}
                    onClick={() => {
                        if (playing) {
                            exposedData?.stop();
                            setPlaying(false);
                            return;
                        }

                        play();
                        setPlaying(true);
                    }}
                    disabled={!rowData.transcript?.bothAudioUrl}
                    size={'compact-xs'}>
                    <FontAwesomeIcon icon={playing ? faStop : faPlay} />
                </Button>
            </Tooltip>
        </Group>
    );
};

const DurationColumn = () => ({
    accessorKey: 'duration',
    header: 'Duration',
    size: 1,
    Cell: ({ cell }) => <DurationCell cell={cell} />,
});
export default DurationColumn;
